import classNames from 'classnames';
import { useMemo } from 'react';
import styles from './AnimationSuccess.module.scss';

const rnd = (from, to) => {
  const length = to - from;
  return Math.random() * length + from;
};

const rndRound = (from, to) => Math.round(rnd(from, to));

const colors = ['blue', 'red', 'yellow', 'green'];
const randomColor = () => colors[rndRound(0, colors.length - 1)];
/**
 * AnimationSuccess
 *
 * @return {JSX.Element}
 */
const AnimationSuccess = ({ className, count = 50 }) => {
  const items = useMemo(
    () =>
      new Array(count).fill(0).map(() => ({
        size: rnd(10, 25),
        left: rnd(0, 100),
        top: rnd(-100, 0),
        rotate: rnd(0, 360),
        color: randomColor(),
        duration: rndRound(3000, 7000),
        skewX: rndRound(3, 30),
        skewY: rndRound(3, 30),
      })),
    [count]
  );

  return (
    <div
      className={classNames(
        styles.AnimationSuccess,
        className,
        AnimationSuccess.displayName
      )}
    >
      {items.map((i, idx) => {
        return (
          <div
            key={idx}
            className={classNames(
              styles.Item,
              // styles[`Item__size__${i.size}`],
              styles[`Item__color__${i.color}`]
            )}
            style={{
              '--size': `${i.size}px`,
              left: `${i.left}%`,
              top: `${i.top}%`,
              transform: `rotate(${i.rotate}deg) skew(${i.skewX}deg, ${i.skewY}deg)`,
              animationDuration: `${i.duration}ms`,
            }}
          />
        );
      })}
    </div>
  );
};

AnimationSuccess.displayName = 'AnimationSuccess';

export default AnimationSuccess;
